export default __webpack_public_path__ + "static/travel3-31faa59b931d928b385f7d73a0820743.png";